<template>
  <a class="underline"><slot /></a>
</template>
